import GroupsSearchBar from "./GroupsSearchBar";
import { MainContentWrapper } from "../../../components/common/Common.styles";
import { useEffect, useState } from "react";
import { setProcessingRequest, setResponseMessage, setResponseValue } from "../../../store/reducers/tableManagementReducer";
import { useAppDispatch } from "../../../hooks/StoreHooks";
import { useResponseValue } from "../../../store/selectors/tableManagementSelector";
import { useServerSidePagination } from "../../../hooks/PaginationHooks";
import { ServerSidePagination } from "../../../components/common/table/ServerSidePagination";
import { fetchActionModules } from "../../../store/thunk/actionsModulesThunk";
import { createGroupThunk, deleteGroupThunk, editGroupThunk, fetchPaginatedGroupsThunk } from "../../../store/thunk/groupsThunk";
import { GroupItem, GroupRequest } from "../../../types/groupItem";
import EditGroupDialog from "./EditGroupDialog";
import GroupsTable from "./GroupsTable";
import { t } from "i18next";
import { mapThunkTypeToResponseValue } from "../../../common/logic/mapThunkTypeToResponseValue";

export default function GroupsBlock() {
  const dispatch = useAppDispatch();
  const responseValue = useResponseValue();
  const [isNewGroupDialogOpen, setIsNewGroupDialogOpen] = useState(false);
  const [editingGroup, setEditingGroup] = useState<GroupItem | undefined>();

  const paginatedData = useServerSidePagination<GroupItem>(
    async (paginationParameters) => {
      const resultAction = await dispatch(fetchPaginatedGroupsThunk(paginationParameters));

      if (fetchPaginatedGroupsThunk.fulfilled.match(resultAction)) {
        return resultAction.payload;
      } else {
        return { items: [], totalCount: 0 };
      }
    },
    []
  );

  useEffect(() => {
    if (responseValue.includes("fulfilled")) {
      dispatch(setResponseValue(""))
      paginatedData.updateTableItems();
    }
  }, [responseValue, paginatedData]);

  useEffect(() => {
    dispatch(fetchActionModules());
  }, []);

  const handleSaveOrCreateGroup = async (group: GroupRequest, id: number | undefined) => {
    dispatch(setProcessingRequest(true));

    if (id) {
      const res = await dispatch(editGroupThunk({group, id}));
      dispatch(setResponseValue(mapThunkTypeToResponseValue(res.type)));
      dispatch(setResponseMessage(t("dialogModals.itemUpdatedGroup")));
    } else {
      const res = await dispatch(createGroupThunk(group));
      dispatch(setResponseValue(mapThunkTypeToResponseValue(res.type)));
      dispatch(setResponseMessage(t("dialogModals.itemCreatedGroup")));
    }

    dispatch(setProcessingRequest(false));
  };

  const handleDeleteGroup = async (group: GroupItem) => {
    dispatch(setProcessingRequest(true));
    const res = await dispatch(deleteGroupThunk(group.id));
    dispatch(setResponseValue(mapThunkTypeToResponseValue(res.type)));
    dispatch(setResponseMessage(t("dialogModals.itemDeletedGroup")));
    dispatch(setProcessingRequest(false));
  };

  return (
    <MainContentWrapper>
      <GroupsSearchBar
        handleOnSearch={paginatedData.handleOnSearch}
        handleOnCreateGroup={() => setIsNewGroupDialogOpen(true)} />

      <GroupsTable
        paginatedData={paginatedData}
        handleDeleteGroup={handleDeleteGroup}
        handleEditGroup={(group) => setEditingGroup(group)}
      />

      <ServerSidePagination paginatedData={paginatedData} />

      {
        isNewGroupDialogOpen && <EditGroupDialog
          onClose={() => setIsNewGroupDialogOpen(false)}
          onSave={handleSaveOrCreateGroup} />
      }
      {
        editingGroup && <EditGroupDialog
          onClose={() => setEditingGroup(undefined)}
          onSave={handleSaveOrCreateGroup}
          group={editingGroup}
        />
      }

    </MainContentWrapper>
  );
};
